import React from 'react';

const Philosophy: React.FC = () => {
  const pillars = [
    {
      title: 'التمكين النفسي',
      description: 'قبل أن تمسكي المقود، نعمل على بناء ثقتك بنفسك وتجاوز أي مخاوف. القيادة تبدأ من العقل والثقة بالنفس.'
    },
    {
      title: 'الإتقان العملي', 
      description: 'نحوّل النظرية إلى ممارسة سلسة. تدريب مكثف على كافة المهارات من أبسطها إلى أكثرها تعقيدًا.'
    },
    {
      title: 'محاكاة الواقع',
      description: 'لا نكتفي بساحات التدريب، بل نأخذكِ إلى الطرق الحقيقية لتتعلمي التعامل مع مواقف الحياة اليومية.'
    }
  ];

  return (
    <section id="philosophy" className="py-16 md:py-32 bg-gradient-to-br from-alice-blue to-white overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="text-center max-w-5xl mx-auto mb-12 md:mb-20">
          <div className="inline-flex items-center bg-lapis-lazuli/10 border border-lapis-lazuli/20 text-lapis-lazuli px-4 md:px-8 py-2 md:py-4 rounded-full text-xs md:text-sm font-medium mb-6 md:mb-10 fade-in">
            منهجنا التعليمي
          </div>
          <h2 className="text-3xl md:text-6xl lg:text-7xl font-black text-prussian-blue mb-6 md:mb-10 leading-tight fade-in fade-in-delay-1">
            منهج المميز<span className="text-celestial-blue">.</span>
          </h2>
          <p className="text-lg md:text-2xl text-prussian-blue/70 leading-relaxed max-w-4xl mx-auto px-4 fade-in fade-in-delay-2">
            نحن لا نتبع القواعد فحسب، بل نغرس فيكِ أسس القيادة الواعية والآمنة. منهجنا يقوم على ثلاث ركائز أساسية:
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-10 max-w-6xl mx-auto px-2">
          {pillars.map((pillar, index) => (
            <div key={index} className="group">
              <div className={`bg-white/80 backdrop-blur-sm rounded-2xl md:rounded-3xl p-6 md:p-10 shadow-lg hover:shadow-2xl transition-all duration-700 scale-hover border border-lapis-lazuli/10 hover:border-celestial-blue/30 h-full fade-in`}
                   style={{animationDelay: `${(index + 3) * 0.2}s`}}>
                <h3 className="text-xl md:text-3xl font-bold text-prussian-blue mb-4 md:mb-8 text-center leading-tight">{pillar.title}</h3>
                <p className="text-prussian-blue/70 leading-relaxed text-center text-sm md:text-lg">{pillar.description}</p>
                
                {/* Decorative element */}
                <div className="mt-6 md:mt-10 flex justify-center">
                  <div className="w-16 h-1 bg-celestial-blue rounded-full transform transition-all duration-500 group-hover:w-20"></div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Additional info section */}
        <div className="mt-16 md:mt-24 text-center fade-in fade-in-delay-4">
          <div className="bg-white/60 backdrop-blur-lg rounded-2xl md:rounded-3xl p-8 md:p-16 border border-lapis-lazuli/20 max-w-5xl mx-auto hover:bg-white/70 transition-all duration-500 scale-hover">
            <h3 className="text-2xl md:text-5xl font-black text-prussian-blue mb-6 md:mb-12">لماذا نختلف؟</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-12 text-prussian-blue/70">
              <div className="space-y-4 md:space-y-6">
                <div className="flex items-start group">
                  <div className="w-2 h-2 bg-celestial-blue rounded-full mt-2 ml-3 flex-shrink-0 transform transition-all duration-300 group-hover:scale-150"></div>
                  <span className="text-sm md:text-lg transition-colors duration-300 group-hover:text-prussian-blue">مدربات متخصصات ومؤهلات</span>
                </div>
                <div className="flex items-start group">
                  <div className="w-2 h-2 bg-celestial-blue rounded-full mt-2 ml-3 flex-shrink-0 transform transition-all duration-300 group-hover:scale-150"></div>
                  <span className="text-sm md:text-lg transition-colors duration-300 group-hover:text-prussian-blue">سيارات حديثة ومجهزة بأحدث التقنيات</span>
                </div>
              </div>
              <div className="space-y-4 md:space-y-6">
                <div className="flex items-start group">
                  <div className="w-2 h-2 bg-celestial-blue rounded-full mt-2 ml-3 flex-shrink-0 transform transition-all duration-300 group-hover:scale-150"></div>
                  <span className="text-sm md:text-lg transition-colors duration-300 group-hover:text-prussian-blue">مرونة في المواعيد والأوقات</span>
                </div>
                <div className="flex items-start group">
                  <div className="w-2 h-2 bg-celestial-blue rounded-full mt-2 ml-3 flex-shrink-0 transform transition-all duration-300 group-hover:scale-150"></div>
                  <span className="text-sm md:text-lg transition-colors duration-300 group-hover:text-prussian-blue">دعم نفسي ومعنوي طوال الرحلة</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Philosophy; 